export default "__VITE_ASSET__DWg7IMIf__"